
define('text!v3/Common/Components/Search/Search.Component.html',[],function () { return '<a href="javascript: void(0);" data-bind="visible: visible, click: openSearch" class="btn btn-default btn-round btn-icon search" style="display:none">\r\n\t<svg class="icon" data-bind="svgIcon: \'Search\'"></svg>\r\n</a>';});

